/**
 * Status helpers + small constants shared between Akten-Live, Dashboard
 * and CaseEditor.  Keeping it in one place avoids the same dictionary
 * being duplicated across the codebase.
 *
 * i18n: `caseStatusLabel(status, t?)` will use the i18n `t` function if
 * provided to look up `case_editor.status.<key>`. Without `t` it falls
 * back to the German default labels (kept here for backwards-compat
 * with code paths that don't have access to a `t` instance — e.g.
 * background scripts, server-side rendering, etc.).
 */

export const CASE_STATUS_META = {
  draft:               { label: "Entwurf",        cls: "bg-zinc-100 text-zinc-700 border-zinc-200" },
  in_progress:         { label: "In Bearbeitung", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  uploaded:            { label: "Hochgeladen",    cls: "bg-cyan-50 text-cyan-800 border-cyan-200" },
  in_review:           { label: "In Prüfung",     cls: "bg-violet-50 text-violet-800 border-violet-200" },
  ready_for_gutachter: { label: "Zur Freigabe",   cls: "bg-[#12A9E8]/10 text-[#12A9E8] border-[#12A9E8]/30" },
  released:            { label: "Freigegeben",    cls: "bg-sky-50 text-sky-800 border-sky-200" },
  sent_to_customer:    { label: "An Kunden",      cls: "bg-blue-50 text-blue-800 border-blue-200" },
  revision_requested:  { label: "Korrektur",      cls: "bg-rose-50 text-rose-800 border-rose-200" },
  completed:           { label: "Fertiggestellt", cls: "bg-[#12A9E8]/10 text-[#12A9E8] border-[#12A9E8]/30" },
  closed:              { label: "Abgeschlossen",  cls: "bg-zinc-900 text-white border-zinc-900" },
};

export function caseStatusLabel(s, t) {
  if (t && CASE_STATUS_META[s]) {
    // Fallback to the German default if the translation key is missing.
    const fallback = CASE_STATUS_META[s].label;
    return t(`case_editor.status.${s}`, fallback);
  }
  return CASE_STATUS_META[s]?.label || s || "—";
}

export function caseStatusCls(s) {
  return CASE_STATUS_META[s]?.cls || "bg-zinc-100 text-zinc-700 border-zinc-200";
}
